import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftDetailResponse } from '@/repositories/generated';

const response: GiftDetailResponse = {
  id: '1',
  name: '〇〇市プレミアム商品券1',
  giftType: 'NORMAL',
  giftStatus: 'SALE',
  salesStartsAt: '2023-04-23T00:00:00+09:00',
  salesEndsAt: '2023-05-23T00:00:00+09:00',
  createdAt: '2023-05-23T00:00:00+09:00',
  updatedAt: '2023-05-23T00:00:00+09:00',
  walletServiceId: '001',
  walletServiceName: 'テストウォレット',
  description: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
  remarks: undefined,
  imageUrl: '/no-image.png',
  giftDetailInfo: [
    {
      id: '1',
      name: '【赤券】（大型店・一般店で利用可能）',
      salesCount: 500,
      setRegisterableCount: 300,
      expiresAtStart: '2023-04-23T00:00:00+09:00',
      expiresAtEnd: '2023-05-23T00:00:00+09:00',
      imageUrl: 'https://stg-nttd-kyotango-web.walletstation.org/images/prepaid-002.png',
    },
    {
      id: '2',
      name: '【赤券】（大型店・一般店で利用可能）',
      salesCount: 500,
      setRegisterableCount: 300,
      expiresAtStart: '2023-04-23T00:00:00+09:00',
      expiresAtEnd: '2023-05-23T00:00:00+09:00',
      imageUrl: undefined,
    },
  ],
};

export const giftDetail = http.get(
  createMockEndpoint('/gift/:id'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);

export default giftDetail;
